var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3163 11.73L18.7663 18.42C18.3013 18.69 17.7163 18.69 17.2363 18.42L5.6863 11.73C4.8613 11.25 4.6513 10.125 5.2813 9.42C5.7163 8.925 6.2113 8.52 6.7363 8.235L14.8663 3.735C16.6063 2.76 19.4263 2.76 21.1663 3.735L29.2963 8.235C29.8213 8.52 30.3163 8.94 30.7513 9.42C31.3513 10.125 31.1413 11.25 30.3163 11.73Z",
    fill: "#009b9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1438 21.21V31.44C17.1438 32.58 15.9887 33.33 14.9687 32.835C11.8787 31.32 6.67375 28.485 6.67375 28.485C4.84375 27.45 3.34375 24.84 3.34375 22.695V14.955C3.34375 13.77 4.58875 13.02 5.60875 13.605L16.3938 19.86C16.8438 20.145 17.1438 20.655 17.1438 21.21Z",
    fill: "#009b9b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 21.21V31.44C18.8555 32.58 20.0105 33.33 21.0305 32.835C24.1205 31.32 29.3255 28.485 29.3255 28.485C31.1555 27.45 32.6555 24.84 32.6555 22.695V14.955C32.6555 13.77 31.4105 13.02 30.3905 13.605L19.6055 19.86C19.1555 20.145 18.8555 20.655 18.8555 21.21Z",
    fill: "#009b9b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0f5c18c52626e5d59ebd89b7376b2d3e.svg";
export { ForwardRef as ReactComponent };